
export default {
  name: 'svgicon',
  components: {},
  props: {
    iconClass: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'svg'
    },
    className: {
      type: String,
      default: ''
    },
    animate:{
      type:Boolean,
      default:false,
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


